
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig"; 

const getAdminModerationLogs = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
    if (params.actionType) queryParams.append('actionType', params.actionType);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);

    const { data } = await axiosInstance.get(`/reports/moderation-logs?${queryParams.toString()}`);
    return data || null;
  } catch (error) {
    console.error("Error fetching moderation logs:", error);
    return null;
  }
};


 const useAdminModerationLogs = (params = {}) => {
  return useQuery({
    queryKey: ["adminModerationLogs", params],
    queryFn: () => getAdminModerationLogs(params),
    enabled: !!params, 
    keepPreviousData: true, 
  });
};

export default useAdminModerationLogs 